import request from '@/utils/request'

let CashApi = {
  /*首页概况*/
  index(data, errorback) {
    return request._post('/shop/cash.cash/index', data, errorback);
  },
  /*首页概况*/
  settled(data, errorback) {
    return request._post('/shop/cash.settled/index', data, errorback);
  },
  getSettledByDate(data, errorback) {
    return request._post('/shop/cash.settled/data', data, errorback);
  },
  /*订单结算*/
  order(data, errorback) {
    return request._post('/shop/cash.order/index', data, errorback);
  },
  /*订单结算详情*/
  orderDetail(data, errorback) {
    return request._post('/shop/cash.order/detail', data, errorback);
  },
  /*订单明细*/
  orderLog(data, errorback) {
    return request._post('/shop/cash.order/orderLog', data, errorback);
  },
  /*订单明细*/
  PromotionLog(data, errorback) {
    return request._post('/shop/cash.Promotion/index', data, errorback);
  },
  /*商户申请取款列表*/
  supplierCashlist(data, errorback) {
    return request._post('/shop/supplier.Cash/index', data, errorback);
  },
  /*商户申请取款审核*/
  supplierCashsubmit(data, errorback) {
    return request._post('/shop/supplier.Cash/submit', data, errorback);
  },
  /*商户申请取款确认*/
  supplierCashmoney(data, errorback) {
    return request._post('/shop/supplier.Cash/money', data, errorback);
  },
  /*用户申请取款列表*/
  incomeStatusList(data, errorback) {
    return request._get('/shop/user.Income/incomeStatusList', data, errorback);
  },
  /*用户申请取款审核*/
  incomeInfosubmit(data, errorback) {
    return request._post('/shop/user.Income/replyIncome', data, errorback);
  },
  /*用户申请取款确认*/
  CashreplyIncome(data, errorback) {
    return request._get('/shop/user.Income/incomeInfo', data, errorback);
  },
    /*推广申请取款列表*/
  PromotionCashlist(data, errorback) {
    return request._post('/shop/user.PromotionCash/index', data, errorback);
  },
  /*用户申请取款审核*/
  PromotionCashsubmit(data, errorback) {
    return request._post('/shop/user.PromotionCash/examine', data, errorback);
  },
}

export default CashApi;



// WEBPACK FOOTER //
// ./src/api/cash.js